import React, { useState, useEffect, useContext } from 'react';
import api from '../utils/api';
import StudentListPopup from './StudentListPopup';
import TeacherListPopup from './TeacherListPopup';
import './styles/TransferInventoryPage.css';
import { BsFiles } from "react-icons/bs";
import { useNavigate } from 'react-router-dom'; 
import AuthContext from '../context/AuthContext';

const StudentRequestLevelupPage = () => {
    const { user } = useContext(AuthContext);
    const [programList, setProgramList] = useState([]);
    const [teacher, setTeacher] = useState('');
    const [levelList, setLevelList] = useState([]);
    const [program, setProgram] = useState('');
    const [level, setLevel] = useState('');
    const [receiver, setReceiver] = useState(null);
    const [sharedTeacher, setSharedTeacher] = useState(null);
    const [showStudentPopup, setShowStudentPopup] = useState(false);
    const [showTeacherPopup, setShowTeacherPopup] = useState(false);
    const [isShareTeacherChecked, setIsShareTeacherChecked] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        api.post('/teacher/extratime/getTeacher', { data: { username: user.username }})
          .then(response => {const teacherData = response.data.data; setTeacher(teacherData);})
          .catch(error => console.error('Error fetching teacher list:', error));
        
        api.get('/utils/getProgramList')
          .then(response => setProgramList(response.data.data.programList))
          .catch(error => console.error('Error fetching program list:', error));
    }, []);
    
    const handleProgramChange = (programId) => {
        api.get(`/utils/getLevelList?program_id=${programId}`)
            .then(response => setLevelList(response.data.data.levelList))
            .catch(error => console.error('Error fetching level list:', error));
        setProgram(programId);
    };

    const handleSelectStudent = (student) => {
        setReceiver(student);
        setShowStudentPopup(false);
    };

    const handleSelectTeacher = (sharedTeacher) => {
        setSharedTeacher(sharedTeacher);
        setShowTeacherPopup(false);
    };
    
    const handleShareTeacherChange = (value) => {  
        setIsShareTeacherChecked(value === 'true');  
        if (value === 'false') {  
            setSharedTeacher(null); // Set sharedTeacher to null when unchecked  
        }  
    };

    const handleSubmit = async () => {
        if (!receiver) {
            alert('Receiver must be selected before submitting.');
            return;
        }

        const confirmation = window.confirm('Are you sure you want to proceed with this action?');
        if (!confirmation) {
            return;
        }
    
        // Mempersiapkan data untuk dikirim
        const levelupData = {
            data: {
                levelupData: {
                    student_id: receiver.student_id, 
                    teacher_id: teacher.teacher_id,
                    program_id: program,
                    level_id: level,
                    sharing_teacher: isShareTeacherChecked,
                    sharing_teacher_id: sharedTeacher ? sharedTeacher.teacher_id : null,
                },
            },
        };

        console.log(levelupData);
        
    
        try {
            const response = await api.post('/student/levelup/create', levelupData); 
            const successMessage = response.data.message;
            console.log(successMessage);
            navigate('/success', { state: { message: successMessage } });
            
        } catch (error) {
            console.error('Error submitting data:', error);
            console.error('Error adding/updating student:', error);
            navigate('/error', { state: { message: 'Please ask to administrator!' } });
        }
    };

    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Student Progress Level</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Student Name</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={receiver ? receiver.student_name : ''} readOnly />
                                            <BsFiles className="icon" onClick={() => setShowStudentPopup(true)} />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Student Code</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={receiver ? receiver.student_code : ''} readOnly />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Share Teacher</label>
                                    </td>
                                    <td>
                                    <select value={isShareTeacherChecked} onChange={(e) => handleShareTeacherChange(e.target.value)}>  
                                            <option value={false}>No</option>
                                            <option value={true}>Yes</option>
                                        </select>
                                    </td>
                                </tr>
                                {isShareTeacherChecked && (
                                <tr>
                                    <td>
                                        <label>Shared Teacher</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                        <input type="text" value={sharedTeacher ? sharedTeacher.teacher_name : ''} readOnly />
                                            <BsFiles className="icon" onClick={() => setShowTeacherPopup(true)} />
                                        </div>
                                    </td>
                                </tr>
                                )}
                                
                                <tr>
                                    <td>
                                        <label>Next Program</label>
                                    </td>
                                    <td>
                                        <select value={program} onChange={(e) => handleProgramChange(e.target.value)}>
                                            <option value="">Select Program</option>
                                            {programList.map(program => (
                                                <option key={program.program_id} value={program.program_id}>
                                                    {program.program_name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Next Level</label>
                                    </td>
                                    <td>
                                        <select value={level} onChange={(e) => setLevel(e.target.value)}>
                                            <option value="">Select Level</option>
                                            {levelList.map(level => (
                                                <option key={level.level_id} value={level.level_id}>
                                                    {level.level_name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="search-container">
                        <button className="profile-button" onClick={handleSubmit}>Submit</button>
                    </div>
                </div>
            </div>
            
            {showStudentPopup && (
                <StudentListPopup 
                    onSelectStudent={handleSelectStudent} 
                    onClose={() => setShowStudentPopup(false)} 
                    branchId={teacher.branch_id} 
                />
            )}
            {showTeacherPopup && (
                <TeacherListPopup 
                onSelectTeacher={handleSelectTeacher} 
                onClose={() => setShowTeacherPopup(false)} 
                branchId={teacher.branch_id} // Kirim branchId ke popup
                />
            )}
        </div>
    );
};

export default StudentRequestLevelupPage;
